import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';

class Executivesix extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"> <Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active">Executive Overview Six Sigma Program </li>
                    </ol>
                </div>
                <section class="course-header bg-blue11" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 six-sigma-bkg" style={{// eslint-disable-next-line
                            backgroundImage: "url(" + "/assets/images/icons/six-sigma-bkg/six-sigma-symbol.svg" + ")",
                        }}>
                            <h1>Executive Overview  <br /> Six Sigma Program </h1>
                            <br /><br /><br />
                            <div class="form-group">
                                <a href="#apply-nows" class="btn btn-md enroll-btn">Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/executive-overview-six-sigma-program');">Download
                                 brochure</button>
                            </div>
                            <br /> <br /><h3> Online Live Training</h3><br /><br />
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <p >Certification jointly awarded by</p>
                            <br />
                            <div class="row">
                                <div class="col-sm-5">
                                    <img alt="executive" width="" src="/assets/images/isi.svg" />
                                </div>
                                <div class="col-sm-1"></div>
                                <div class="col-sm-5">
                                    <img alt="executive2" width="" src="/assets/images/epn.svg" />
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z">
                    <div class="card" id="Description">
                        <div class="row contanint-display">
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6">
                                <b >Schedule :</b><br />

                            </div>
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6" >
                                <b> <i class="fa fa-calendar" ></i>&nbsp; Upto 2 Days</b><br />
                                <b>(Customisable as per requirements)</b>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Agenda">Program Agenda</a></li>
                            <li><a href="#Eligibility">Eligibility</a></li>
                            <li><a href="#Schedule">Schedule</a></li>
                            <li><a href="#Review-s">Learner Review </a></li>
                            <li><a href="#Certification-s">Certification</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-nows">Enroll Now</a></li>
                        </ul>
                    </div>
                </section>
                <br />
                <section class="course-description" id="course-description">
                    <div class="row">
                        <div class="col-sm-12">
                            <br />
                            <h3  >Program Overview</h3>
                            <p align="justify">Organizations and companies of all sizes are cutting costs and boosting their productivity and profitability by introducing Six Sigma. In the global age of uncertainty and competition, Six Sigma provides the tools and techniques to improve business processes and increase profitability.</p>

                        </div>

                    </div>
                    <br />
                    <div class="row" >
                        <div class="col-sm-10">
                            <h3>Benefits of the Program</h3>
                        </div>
                    </div>

                    <div class="row" id="Eligibility">
                        <div class="col-md-12 col-sm-12">
                            <ul class="highlight-ul" >
                                <li > Six Sigma program allows you to make operational improvements to create efficiencies for your business</li>
                                <li>The program will help you address customer needs and improve loyalty</li>
                                <li id="Agenda">By lowering operating costs and ensuring faster delivery of products and services, you are ensured of better returns</li>
                            </ul>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <h3 > Who Should Enroll ?</h3>
                            <ul class="highlight-ul">
                                <li>Executive members of an organization</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section class=" course-program-agenda bg-secondary padding" id="course-industry-trends">
                    <div class="row">
                        <div class=" col-md-12 col-sm-12">
                            <h3> Program Agenda </h3>
                            <ul class="highlight-ul" >
                                <li> Introduction</li>
                                <li> Business Performance Improvement Initiatives such as Balance Scorecard, HosinKanrie, Six Sigma, WCM, etc. </li>
                                <li>Business Level Dashboard - Workshop</li>
                                <li id="Schedule"> Project Hopper and Project Selection - Workshop </li>
                                <li>Organization for Six Sigma and Role of Leadership teams and Champions </li>
                                <li>Six Sigma approaches - DMAIC, DFSS and LSS </li>
                                <li>Case studies</li>
                                <li> Six Sigma Deployment for the Organization</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Certification</h3>
                            <br />
                            <ul >
                                <li>The Indian Statistical Institute, Pune and edu plus now will award participants a formal certificate on completion of the course.</li>
                            </ul>
                            <br />
                        </div>
                        <div class="col-sm-6">
                            <img alt="executive8" src="/assets/images/icons/certificate-final.png" />
                            <br /><br />
                            <p class="img-below-text text-center">Awarded Jointly by The Indian Statistical Institute,Pune and
                             edu plus now </p>
                            <span id="apply-nows"></span>
                        </div>
                    </div>
                    <br /><br />
                </section>
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br />
                                        <h5>Who will Benefits of the Program</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li> Six Sigma program allows you to make operational improvements to create efficiencies for your business</li>
                                            <li>The program will help you address customer needs and improve loyalty</li>
                                            <li>By lowering operating costs and ensuring faster delivery of products and services, you are ensured of better returns</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About the Organization</h3>
                            <br />
                            <img alt="executive5" width="" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                                 </p>
                            <br />
                            <p align="justify">ISI Pune is a unit of Indian Statistical Institute,Pune, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                                     Data Analytic, Data Science. </p>
                        </div>

                    </div>
                </section>
                <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header" >
                                <span class="close" id="close_form"
                                    data-dismiss="modal">&times;</span>
                                <br />
                            </div>
                            <div class="modal-body" >
                                <div class="panel panel-default paper-shadow box_detail" >
                                    <h5 class="text-center "> Download The Course Brochure </h5>
                                    <form method="post" class="form-row" onsubmit="return validate()">

                                        <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                            required="" autocomplete="on" name="name" id="name" />
                                        <b>Your email</b><input class="form-control" type="email" required=""
                                            autocomplete="on" name="emaill" id="emaill" />
                                        <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                            type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                        <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />

                                        <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                        <br />
                                        <div>
                                            <div class="form-group">
                                                <div id="recaptcha" class="g-recaptcha"
                                                    data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                                <div id="captcha"></div>
                                            </div>
                                        </div>
                                        <div class="mob_cb" >
                                            <div>
                                            </div><br />
                                            <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)" id="exd-download" ><i class="icon-download"></i> Brochure</button></div>
                                        <br />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Executivesix;